module.exports = __webpack_public_path__ + "media/images/emoticons/wine-67424308bd3fb369fed2ef1e813ba9c4.gif";